import { Component } from '@angular/core';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-pw-setnew',
    standalone: false,

    templateUrl: './pw-setnew.component.html',
    styleUrl: './pw-setnew.component.scss'
})
export class PwSetnewComponent {
    hidespinner: boolean = true;
    setpwForm: FormGroup;
    resetId: string = ""
    isValid: boolean = false;
    checkProvided: boolean = false;

    constructor(
        private authService: AuthandregistryService,
        private _fb: FormBuilder,
        private router: Router,
    ) {
        // get ResetId from URL
        this.resetId = window.location.pathname.split('/').pop() || "";
        if (this.resetId.indexOf('?') !== -1) {
            this.resetId = this.resetId.split('?')[0];
        }

        if(this.resetId !== "") {
            this.checkPwLink();
        }

        console.log("ResetID:", this.resetId);
        this.setpwForm = this._fb.group({
            password: ['', Validators.required],
        });
    }
    async checkPwLink() {
        this.hidespinner = false;
        this.isValid = await this.authService.checkPasswordLink(this.resetId);
        this.checkProvided = true;
        this.hidespinner = true;

    }
    async onSubmit() {
        if (this.setpwForm.invalid || typeof this.setpwForm.value.password !== 'string') return;

        this.hidespinner = false;
        let result = await this.authService.setNewPassword(this.resetId, this.setpwForm.value.password);
        this.hidespinner = true;

        console.log("Result for PW reset", result);

        // Navigation is handled in AuthandregistryService on successful reset/login.
        // On errors we stay on the page so the user can request a new reset link.
        if (result === true) {
            return;
        }

    }


}
